import type { DashboardAlertsTranslations } from "../interfaces/dashboardAlerts";

export const dashboardAlertsTranslations: DashboardAlertsTranslations = {
  alert_payin_title: "Llegó un pago de {{amount}}",
  alert_payin_from: "De {{name}}",
  alert_payin_collection_via: "Cobro por {{rail}}",
  alert_payout_paid_title: "Tu envío de {{amount}} llegó",
  alert_payout_failed_title: "Tu envío de {{amount}} no se completó",
  alert_payout_failed_body: "Abre el detalle para ver qué pasó.",
  alert_payout_via: "Por {{rail}}",
  alert_batch_completed_title: "Tu lote de pagos terminó",
  alert_batch_completed_with_errors_title: "Tu lote de pagos terminó con errores",
  alert_batch_failed_title: "Tu lote de pagos no se pudo completar",
  alert_batch_paid: "{{count}} pagados",
  alert_batch_failed_rows: "{{count}} con error",
  alert_batch_paid_one: "1 pagado",
  alert_batch_failed_rows_one: "1 con error",
  alert_card_approved_title: "Compra aprobada de {{amount}}",
  alert_card_declined_title: "Compra rechazada de {{amount}}",
  alert_card_refund_title: "Reembolso de {{amount}} a tu tarjeta",
  alert_card_reversal_title: "Se reversó una compra de {{amount}}",
  alert_card_detail: "Tarjeta •••• {{last4}}",
  alert_card_approved_no_amount: "Compra aprobada con tu tarjeta",
  alert_card_declined_no_amount: "Compra rechazada en tu tarjeta",
  alert_card_refund_no_amount: "Reembolso a tu tarjeta",
  alert_card_reversal_no_amount: "Se reversó una compra",
  alert_view_transaction: "Ver transacción",
  alert_view_batch: "Ver lote",
  summary_payins_breb_key: "Llegaron {{count}} pagos a tus llaves",
  summary_payins_collections: "Te pagaron {{count}} cobros",
  summary_payouts_paid: "Llegaron {{count}} de tus envíos",
  summary_payouts_failed: "{{count}} envíos no se completaron",
  summary_payout_batches_done: "Terminaron {{count}} lotes de pagos",
  summary_cards_purchase_approved: "{{count}} compras aprobadas con tus tarjetas",
  summary_cards_purchase_declined: "{{count}} compras rechazadas en tus tarjetas",
  summary_cards_refund: "{{count}} reembolsos a tus tarjetas",
  summary_total: "{{amount}} en total",
  summary_view: "Ver todos",
  section_eyebrow: "Notificaciones",
  section_title: "Avisos en el dashboard",
  section_sub:
    "Un mensaje en la esquina de la pantalla cuando pasa algo, mientras tienes el dashboard abierto. Si llegan varios seguidos, se juntan en uno.",
  section_count: "{{on}} de {{total}} activos",
  group_payins: "Pagos entrantes",
  group_payouts: "Envíos",
  group_payout_batches: "Pagos por lote",
  group_cards: "Tarjetas",
  type_payins_breb_key: "Pagos a tus llaves Bre-B",
  type_payins_breb_key_hint:
    "Cuando alguien te paga con tu QR para cualquier monto o escribiendo tu llave. Con el QR abierto, el aviso sale dentro del QR.",
  type_payins_collections: "Cobros pagados",
  type_payins_collections_hint:
    "Cuando te pagan un cobro que creaste: QR con monto, PSE, Nequi, Botón Bancolombia, PIX o SPEI, o una transferencia a tu cuenta.",
  type_payouts_paid: "Envíos que llegaron",
  type_payouts_paid_hint: "Cuando el destino confirma un envío que hiciste.",
  type_payouts_failed: "Envíos que no se completaron",
  type_payouts_failed_hint: "Cuando un envío es rechazado o reversado.",
  type_payout_batches_done: "Lotes terminados",
  type_payout_batches_done_hint: "Cuando un lote de pagos termina de ejecutarse, con o sin errores.",
  type_cards_purchase_approved: "Compras aprobadas",
  type_cards_purchase_approved_hint: "Cada compra aprobada con las tarjetas de tu organización.",
  type_cards_purchase_declined: "Compras rechazadas",
  type_cards_purchase_declined_hint: "Cuando el comercio o el emisor rechaza una compra.",
  type_cards_refund: "Reembolsos y reversos",
  type_cards_refund_hint: "Cuando un comercio devuelve dinero a una tarjeta o se reversa una compra.",
  browser_note: "Se guardan en este navegador: en otro computador o celular puedes elegir distinto.",
  whatsapp_note: "¿También por WhatsApp, aunque no tengas el dashboard abierto?",
  whatsapp_payments_link: "Avisos de pagos",
  whatsapp_cards_link: "Avisos de tarjetas",
  sound_label: "Sonido de los avisos",
  sound_hint: "Apágalo para silenciarlos todos sin cambiar lo que elegiste en cada uno.",
  mode_sound: "Con sonido",
  mode_silent: "Sin sonido",
  mode_off: "Apagado",
  mode_group_aria: "Cómo te avisamos de {{label}}",
  sound_listen: "Escuchar",
  sound_listen_problem: "Si falla",
  sound_desc_payins: "Una campanita que sube.",
  sound_desc_payouts: "Dos golpes de madera: suben si llegó, bajan si no.",
  sound_desc_payout_batches: "Tic, tic, tic y una campana; baja si algo falló.",
  sound_desc_cards: "El bip-bip del datáfono; un bip que baja si la rechazan.",
  intro_title: "Así te avisamos",
  intro_body:
    "Cuando pasa algo con tu dinero, te avisamos con un mensaje arriba en la pantalla mientras tienes el dashboard abierto. Cada sección suena distinto, para que sepas qué es sin mirar.",
  intro_footer: "Elige cuáles suenan, cuáles solo se ven y cuáles apagar.",
  intro_settings: "Configurar avisos",
  intro_dismiss: "Entendido",
  intro_close: "Cerrar",
};
